<div class="modal  modal-lg fade show" style="display: block; padding-right: 15px;">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">Sort page content</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="cancel()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                </button>
			</div>
			<div class="modal-body">
                <p>Drag the page sections into your desired order</p>
                <div class="dd">
					<ol class="dd-list"
						style="padding-inline-start: 0;"
						dragula="roomImages"
						[(dragulaModel)]="snippets"
						(dragulaModelChange)="drop($event)">
						<li class="dd-item" *ngFor="let snippet of snippets">
							<div class="dd-handle"style="cursor: move">
								<span class="label label-info" >
									<i class="fa fa-bars"></i>
								</span>
								{{snippet.name}}
							</div>
						</li>
					</ol>
				</div>


			</div>

			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="save()">Save changes</button>
			</div>
		</div>
	</div>
</div>

<div class="modal-backdrop fade show"></div>


